import React, { useState } from "react";
import Button from "../Button";
import Header from "../header";
import { Link } from "react-router-dom";
import { RiArrowRightFill } from "react-icons/ri";
import BuyTokenModel from "../../components/BuyTokenModel/index.jsx";

const Hero = ({cont_address,find_Exp_usdt ,find_Exp_Token, buying_Amount, set_buying_Amount, selling_Amount, set_selling_Amount, purchaseToken, sellToken }) => {

  const [open, setOpen] = useState(false);

  // const openPdfInNewTab = () => {
  //   const pdfUrl = require("../../assets/images/Exornod_plan.pdf");
  //   window.open(pdfUrl, "_blank");
  // };

  return (
    <div className="tw-mb-10 tw-bg-cover tw-relative tw-bg-center tw-w-full tw-h-auto">

      <Header />

      <div className="container tw-mx-auto tw-relative tw-pt-6">

        <div className="row sm:tw-text-left tw-text-center g-5 tw-items-center">

          <div className="col-lg-6 col-md-12">

            <h1 className="tw-font-Dots tw-pt-2 text-white md:tw-text-5xl tw-text-3xl">
              Shaping the Future <br />
              of{" "}
              <span className="hero-title-gradient tw-font-Dots">
                Decentralized
              </span>{" "}
              <span className="hero-title-gradient tw-font-Dots">
                Innovation
              </span>
            </h1>

            <p className="tw-text-white sm:tw-text-start tw-text-center tw-font-extralight tw-leading-7 tw-pt-4 tw-text-lg">
              A secure ecosystem for Dapps, blockchain solutions, and
              community-driven technologies. Experience the next evolution in
              decentralized finance.
            </p>

            <div className="tw-flex tw-flex-row tw-justify-center sm:tw-justify-start sm:tw-gap-4 tw-gap-2 tw-items-center tw-pt-4">

              <Button
                className="tw-text-black sm:tw-text-base tw-text-xs tw-whitespace-nowrap tw-rounded-lg"
                label={"Read Plan"}
              />

              <Button
                onClick={() => setOpen(true)}
                className="tw-text-black sm:tw-text-base tw-text-xs tw-whitespace-nowrap tw-rounded-lg"
                label={"Swap Token"}
              />

            </div>

          </div>

          <div className="col-lg-6 col-md-12 tw-flex tw-justify-center tw-items-center">
            <div className="tw-relative tw-w-full">
              <img
                src={require("../../assets/images/home.png")}
                className="tw-w-full tw-relative tw-z-10"
                alt=""
              />
            </div>
          </div>

        </div>

      </div>

      <div className="tw-absolute -tw-z-10 tw-left-0 tw-top-0">
        <img src={require("../../assets/images/home_left.png")} alt="" />
      </div>

      {/* MODAL POPUP */}
      {open && (
        <div
          className="tw-fixed tw-inset-0 tw-bg-black/70 tw-flex tw-items-center tw-justify-center tw-z-50"
          onClick={() => setOpen(false)}
        >

          <div
            className="tw-relative"
            onClick={(e) => e.stopPropagation()}
          >

            {/* Close Button */}
            <button
              onClick={() => setOpen(false)}
              className="tw-absolute tw-top-2 tw-right-3 tw-text-white tw-text-xl tw-z-50"
            >
              ✕
            </button>

            <BuyTokenModel setOpen={setOpen} find_Exp_usdt={find_Exp_usdt} find_Exp_Token={find_Exp_Token} buying_Amount={buying_Amount} set_buying_Amount={set_buying_Amount} selling_Amount={selling_Amount} set_selling_Amount={set_selling_Amount} purchaseToken={purchaseToken} sellToken={sellToken} />

          </div>

        </div>
      )}

    </div>
  );
};

export default Hero;